"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineDateCSS = exports.DateToolbox = void 0;
var DateToolbox = function DateToolbox(Survey, QuestionDateModel) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (x) {
    return x;
  };
  var widget = {
    name: 'dateCustom',
    title: 'Date',
    iconName: '',
    widgetIsLoaded: function widgetIsLoaded() {
      return true;
    },
    isFit: function isFit(question) {
      return question.getType() === 'dateCustom';
    },
    init: function init() {
      Survey.Serializer.addClass('dateCustom', [{
        name: '!name',
        displayName: t('Field ID'),
        category: 'general',
        visibleIndex: 0
      }, {
        name: 'title:input',
        displayName: t('Field Name'),
        category: 'general',
        visibleIndex: 1
      }, {
        name: 'description:input',
        displayName: t('Field Description'),
        maxLength: 160,
        category: 'general',
        visibleIndex: 2
      }, {
        name: 'visible',
        displayName: t('Is this field visible?'),
        default: true,
        category: 'general',
        visibleIndex: 6
      }, {
        name: 'isRequired',
        displayName: t('Is this field required?'),
        default: false,
        category: 'general',
        visibleIndex: 7
      }, {
        name: 'readOnly',
        displayName: t('Is this field read only?'),
        default: false,
        category: 'general',
        visibleIndex: 8
      }, {
        name: 'requiredErrorText',
        displayName: t('Required Error Text'),
        default: false,
        category: 'validation'
      }, {
        name: 'min',
        displayName: t('Min'),
        visibleIndex: 4,
        category: 'general',
        dependsOn: ['datetype', 'max'],
        type: 'minMaxCustom'
      }, {
        name: 'max',
        displayName: t('Max'),
        dependsOn: ['datetype', 'min'],
        visibleIndex: 5,
        category: 'general',
        type: 'minMaxCustom'
      }, {
        name: 'defaultValueExpression',
        displayName: t('Default value expression'),
        category: 'logic'
      }, {
        name: 'maxValueExpression',
        displayName: t('Max value expression'),
        category: 'logic'
      }, {
        name: 'minValueExpression',
        displayName: t('Min value expression'),
        category: 'logic'
      }], function () {
        return new QuestionDateModel('');
      }, 'text');
    },
    isDefaultRender: true
  };
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'dateCustom');
};
exports.DateToolbox = DateToolbox;
var defineDateCSS = function defineDateCSS(survey) {
  survey.onUpdateQuestionCssClasses.add(function (_, options) {
    var classes = options.cssClasses;
    if (options.question.getType() === 'dateCustom') {
      classes.mainRoot = "".concat(classes.mainRoot, " sd-row__question--small");
    }
  });
};
exports.defineDateCSS = defineDateCSS;